<div class="modal-wrapper">
  <div class="overlay" *ngIf="showLoader">
    <app-spinner></app-spinner>
  </div>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">Scrape progress</h4>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p-table [value]="items">
      <ng-template pTemplate="header">
        <tr>
          <th>Company Name</th>
          <th>Status</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr>
          <td>{{ item.name }}</td>
          <td *ngIf="!isStatusCompleted(item)">{{ getStatusDescription(item) }}</td>
          <td *ngIf="isStatusCompleted(item)">
            <button class="progress-link" (click)="downloadScreenshot(item)"><i class="material-icons">launch</i> Completed</button>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="close()">OK</button>
  </div>
  <div *ngIf="isDebugInfo" class="modal-footer">
    <p class="debugInfo">
      Last progress update: {{ timer }} s<br />
      Total duration: {{ timerTotalDuration }}<br />
      Scrape job id: {{ scrapeJobId }}
    </p>
  </div>
</div>
